import React from "react";
import {Outlet, Navigate, RouteProps, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import {isLoggedIn} from "modules/selectors";
import {get} from "lodash";

export const NotAuthOnlyRoute: React.FC<RouteProps> = () => {
	const location = useLocation();
	const backURL = get(location, "state.from.pathname", "/") as string;

	// if he came from another location, return it back
	return useSelector(isLoggedIn) ? <Navigate to={backURL} /> : <Outlet />;
};
